<template>
    <div>
        <h2 class="font-bold text-md text-cyan-600">{{ title }}</h2>
        <p class="font-light text-sm text-cyan-600">{{ subtitle }}</p>
    </div>
</template>

<script>
export default {
    props: {
        title: String,
        subtitle: String
    }
}
</script>
